module.exports = __webpack_public_path__ + "assets/img/226201.e8af2db5.png";